module.exports = __webpack_public_path__ + "images/apple-v-apple-chromium-570w.webp";